'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserLastName = exports.getUserFirstName = exports.getUserName = exports.getAccessToken = exports.getUserRole = exports.getUserRoles = exports.getUserEmail = exports.getUserId = exports.getPartnerId = exports.getUser = exports.isRedirectUri = undefined;

var _OidcUserManager = require('../services/OidcUserManager');

/**
 * Returns true if currently navigated to the callback component redirect url
 * Includes protocol, hostname, port, pathname, and query parameters
 */
var isRedirectUri = exports.isRedirectUri = function isRedirectUri() {
  var port = window.location.port ? ':' + window.location.port : '';
  var currentUri = window.location.protocol + '//' + window.location.hostname + port + window.location.pathname + window.location.search;
  var redirectUri = (0, _OidcUserManager.userManager)().settings.redirect_uri;

  return currentUri.startsWith(redirectUri);
};

var getUser = exports.getUser = function getUser(state) {
  if (!state) {
    return undefined;
  }

  return state.get('user');
};

var getPartnerId = exports.getPartnerId = function getPartnerId(state) {
  if (!state) {
    return undefined;
  }

  return state.getIn(['user', 'profile', 'partner_id']);
};

var getUserId = exports.getUserId = function getUserId(state) {
  if (!state) {
    return undefined;
  }

  return state.getIn(['user', 'profile', 'sub']);
};

var getUserEmail = exports.getUserEmail = function getUserEmail(state) {
  if (!state) {
    return undefined;
  }

  return state.getIn(['user', 'profile', 'email']);
};

var getUserRoles = exports.getUserRoles = function getUserRoles(state) {
  if (!state) {
    return undefined;
  }

  return state.getIn(['user', 'profile', 'roles']);
};

var getUserRole = exports.getUserRole = function getUserRole(state) {
  if (!state) {
    return undefined;
  }

  return state.getIn(['user', 'profile', 'role']);
};

var getAccessToken = exports.getAccessToken = function getAccessToken(state) {
  if (!state) {
    return undefined;
  }

  return state.getIn(['user', 'access_token']);
};

var getUserName = exports.getUserName = function getUserName(state) {
  if (!state) {
    return undefined;
  }

  return state.getIn(['user', 'profile', 'name']);
};

var getUserFirstName = exports.getUserFirstName = function getUserFirstName(state) {
  if (!state) {
    return undefined;
  }

  return state.getIn(['user', 'profile', 'given_name']);
};

var getUserLastName = exports.getUserLastName = function getUserLastName(state) {
  if (!state) {
    return undefined;
  }

  return state.getIn(['user', 'profile', 'family_name']);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/OidcService.js
// module id = 149
// module chunks = 10